// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"c0e113d3bbb667e17c9d","966":"6f42d382afce9ea034aa"}[chunkId] + ".js";
};